import { axiosGet } from '../ServiceBase.js';

export const buscarDelegaciones = async (data) => {
  const delegaciones = await axiosGet('/v1/busquedas/buscarDelegaciones');
  return delegaciones;
};
